import { getRgObjectsOfType as o, RG_TYPE as i } from "@project-rouge/rg-core";
import { SumArray as c } from "../../../utils/array/index5.js";
const p = (r) => {
  let t = 0;
  const e = o(r, i.Building);
  for (const a of e) {
    const n = o(a, i.Apartment);
    if (!n.length)
      continue;
    const s = n.map((m) => m.data.nia || 0);
    t += c(s);
  }
  return t;
};
export {
  p as getNIA
};
//# sourceMappingURL=index38.js.map
